import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=11c35444&scoped=true&"
import script from "./FAQ.js?vue&type=script&lang=js&"
export * from "./FAQ.js?vue&type=script&lang=js&"
import style0 from "./FAQ.scss?vue&type=style&index=0&id=11c35444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c35444",
  null
  
)

export default component.exports